module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_08-2c186b962e9aa630961fe61ac0a35f36.webp";